import React from 'react';
import PropTypes from 'prop-types';
import MaterialLinearProgress from '@material-ui/core/LinearProgress';

const LinearProgress = ({ color, className, style }) => {
  return <MaterialLinearProgress color={color} className={className} style={style} />;
};

LinearProgress.propTypes = {
  color: PropTypes.oneOf(['primary', 'secondary', 'inherit']),
};

LinearProgress.defaultProps = {
  color: 'primary',
};

export default LinearProgress;
